import { render, staticRenderFns } from "./FoodGroupDetail.vue?vue&type=template&id=4aea7161&"
import script from "./FoodGroupDetail.vue?vue&type=script&lang=js&"
export * from "./FoodGroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./FoodGroupDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports